module.exports = __webpack_public_path__ + "media/video.e3f602e7.mp4";